const SHOW_UNDO_DELETION_OF_FURNITURE = 'SHOW_UNDO_DELETION_OF_FURNITURE';

export { SHOW_UNDO_DELETION_OF_FURNITURE };
